import axios from "axios";
import { Partner_Service_URL, Payout_Service } from "../Url";

export const pricingPartnerAction = {
  PARTNER_DATA_SUCCESS: "PARTNER_DATA_SUCCESS",
  PARTNER_DATA_ERROR: "PARTNER_DATA_ERROR",
};

export function partnerDataSuccess(props) {
  const {accessToken } = props;
  return async (dispatch) => {
    //   const data = PartnerPricingdata;
    try {
      const response = await axios({
        method: "POST",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        // url: "http://localhost:8010/edge-service/partner-service/get/PartnerDetails/active",
        // url: "http://localhost:8171/partner-service/get/PartnerDetails/active",
        url: `${Partner_Service_URL}/get/PartnerDetails/active`,
      });
      const data = response.data;
      dispatch({
        type: pricingPartnerAction.PARTNER_DATA_SUCCESS,
        payload: data.data,
      });
      return data.data;
    } catch (error) {
      console.error("Error:", error);
      dispatch({
        type: pricingPartnerAction.PARTNER_DATA_ERROR,
        payload: error.message || "Failed to fetch partner data",
      });
      return error;
    }
  };
}
